import React from "react";
import { Panel } from "./common";

const Step = ({ n, children }) => (
  <li className="flex gap-3"><span className="w-6 h-6 rounded-full bg-forest text-white text-xs flex items-center justify-center shrink-0">{n}</span><div className="text-sm">{children}</div></li>
);
const Code = ({ children }) => <code className="block bg-neutral-900 text-green-200 text-xs rounded-lg p-2 mt-1 break-all">{children}</code>;

export default function SetupGuide() {
  const url = window.location.origin;
  return (
    <div className="grid lg:grid-cols-2 gap-4" data-testid="setup-guide">
      <Panel title="1. Ресторантски термопринтер 80 мм">
        <ol className="space-y-3">
          <Step n={1}>Инсталирайте драйвера на принтера в Windows (от диска или сайта на производителя).</Step>
          <Step n={2}>Windows → Настройки → Принтери: направете термопринтера <b>принтер по подразбиране</b> на компютъра в ресторанта.</Step>
          <Step n={3}>В настройките на драйвера изберете хартия <b>80 мм (72 мм печатна ширина)</b>, полета 0.</Step>
          <Step n={4}>За печат с <b>едно натискане, без прозорец</b>: създайте пряк път на работния плот към Google Chrome с този адрес:
            <Code>"C:\Program Files\Google\Chrome\Application\chrome.exe" --kiosk-printing {url}/app/pos</Code>
            Отваряйте програмата винаги от този пряк път. Затворете всички други прозорци на Chrome преди това.</Step>
          <Step n={5}>Натиснете „Тестов печат“ в раздел „Ресторантски принтер“.</Step>
        </ol>
      </Panel>
      <Panel title="2. Хотелски принтер A4">
        <ol className="space-y-3">
          <Step n={1}>На компютъра на рецепцията направете офис принтера <b>принтер по подразбиране</b>.</Step>
          <Step n={2}>Хартия A4, портрет. Използвайте същия пряк път с <b>--kiosk-printing</b>, но с адрес {url}/app/invoices.</Step>
          <Step n={3}>Ако ресторантът и рецепцията са на <b>един компютър</b>: Chrome печата на последно използвания принтер. Тогава използвайте нормален прозорец за печат (без --kiosk-printing) и изберете принтера ръчно.</Step>
          <Step n={4}>Бутонът „PDF“ изтегля фактурата като файл – работи на всеки компютър.</Step>
        </ol>
      </Panel>
      <Panel title="3. Фискално устройство (когато го закупите)">
        <ol className="space-y-3">
          <Step n={1}>Изберете ФУ, поддържано от безплатната програма <b>ErpNet.FP</b> (Datecs, Tremol, Daisy, Eltrade, Incotex). Регистрацията в НАП се прави от вашия сервиз.</Step>
          <Step n={2}>Изтеглете и стартирайте ErpNet.FP на компютъра в ресторанта: github.com/erpnet/ErpNet.FP</Step>
          <Step n={3}>В раздел „Фискално устройство“ натиснете „Провери връзката“, изберете устройството, включете превключвателя и запазете.</Step>
          <Step n={4}>След плащане бонът се изпраща автоматично към ФУ. Ако ФУ не отговаря, се печата служебен бон и се показва предупреждение.</Step>
        </ol>
      </Panel>
      <Panel title="Важно">
        <ul className="list-disc pl-5 text-sm space-y-2">
          <li>Уеб браузърите не позволяват на сайтове сами да откриват или избират принтери – затова принтерът се избира в Windows като принтер по подразбиране.</li>
          <li>Връзката с ФУ е подготвена, но не е тествана с истинско устройство. Проверете я заедно със сервиза при инсталирането.</li>
          <li>Издадените фактури не могат да се редактират. При грешка анулирайте фактурата и издайте нова.</li>
        </ul>
      </Panel>
    </div>
  );
}
